var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Dropdown from "reactstrap/lib/Dropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import { ARROW_DOWN_SVG } from "../assets";
import DropdownItem from "reactstrap/lib/DropdownItem";
var DropDown = /** @class */ (function (_super) {
    __extends(DropDown, _super);
    function DropDown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            displayDefault: true
        };
        return _this;
    }
    DropDown.prototype.getText = function () {
        var _this = this;
        if (this.state.displayDefault && this.props.defaultSelected) {
            var value = this.props.dataSource.find(function (t) { return _this.props.keyExtractor(_this.props.defaultSelected) == _this.props.keyExtractor(t); });
            if (value) {
                return this.props.valueExtractor(value);
            }
        }
        if (this.props.selected) {
            var value = this.props.dataSource.find(function (t) { return _this.props.keyExtractor(_this.props.selected) == _this.props.keyExtractor(t); });
            if (value) {
                return this.props.valueExtractor(value);
            }
        }
        return this.props.selectText;
    };
    DropDown.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: "bpm-dropdown " + (this.props.className || ''), style: this.props.style },
            React.createElement("div", { className: "dropdown-container" },
                React.createElement(Dropdown, { direction: 'down', isOpen: this.state.isOpen, toggle: function () { return _this.setState({ isOpen: !_this.state.isOpen }); } },
                    React.createElement(DropdownToggle, { className: "dropdown-toggle" },
                        React.createElement(Row, null,
                            React.createElement(Col, { className: "dropdown-text my-auto " + (this.props.selected ? '' : 'placeholder') },
                                React.createElement("div", null, this.getText())),
                            React.createElement(Col, { className: "arrow-col" },
                                React.createElement("img", { className: 'arrow', src: ARROW_DOWN_SVG })))),
                    React.createElement(DropdownMenu, { className: "dropdown-menu" },
                        this.props.selectText && React.createElement(DropdownItem, { className: "bpm-dropdown-item my-auto " + (!this.props.selected ? 'selected' : ''), onClick: function () { return _this.props.onValueSelected(); } }, this.props.selectText),
                        this.props.dataSource.map(function (value) {
                            return React.createElement(DropdownItem, { className: "bpm-dropdown-item my-auto " + ((_this.props.selected && _this.props.keyExtractor(_this.props.selected) == _this.props.keyExtractor(value)) ? 'selected' : ''), key: _this.props.keyExtractor(value), onClick: function () {
                                    _this.props.onValueSelected(value);
                                    _this.setState({ displayDefault: false });
                                } }, _this.props.valueExtractor(value));
                        })))));
    };
    return DropDown;
}(React.PureComponent));
export default DropDown;
//# sourceMappingURL=DropDown.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/DropDown.js
// module id = 191
// module chunks = 0